import { Charge } from '../../../../../entities/hydra';

/**
 * Filters charges by charge ID or associated invoice numbers.
 *
 * Returns the full array unchanged when `searchTerm` is blank.
 */
export const filterCharges = (charges: Charge[], searchTerm: string): Charge[] => {
  if (searchTerm.trim() === '') {
    return charges;
  }
  const searchLower = searchTerm.toLowerCase();
  return charges.filter(charge => {
    const chargeId = charge.id?.toString() ?? '';
    const invoiceNumbers = (charge.chargeHasTaxes ?? [])
      .map(cht => cht.invoice?.invoiceNumber ?? '')
      .join(' ');
    return chargeId.toLowerCase().includes(searchLower)
      || invoiceNumbers.toLowerCase().includes(searchLower);
  });
};

/**
 * Filters invoice dropdown options by the active search term.
 *
 * Only options whose label (invoice number) or value (invoice ID as string) contain
 * the search string (case-insensitive) are returned.
 * Returns all options unchanged when `searchTerm` is blank.
 */
export const filterInvoiceOptions = (
  options: Array<{ label: string; value: string }>,
  searchTerm: string,
): Array<{ label: string; value: string }> => {
  if (searchTerm.trim() === '') {
    return options;
  }
  const searchLower = searchTerm.toLowerCase();
  return options.filter(option =>
    option.label.toLowerCase().includes(searchLower)
    || option.value.toLowerCase().includes(searchLower),
  );
};
